import { useState } from "react"
import styled from "styled-components"

import { Button, PinInput, spacing } from "@minuthq/meatball-ui-react"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { postValidateMfa } from "src/domains/auth/auth-queries"
import { useMutation } from "src/domains/http/use-mutation"
import { useTranslate } from "src/domains/i18n/use-translate"
import backdropImage from "src/ui/assets/buildings-orange-brown.jpg"
import { PageLayout } from "src/ui/page-layout/page-layout"

export const Route = createFileRoute("/mfa/validate")({
  component: MfaValidate,
})

function MfaValidate() {
  const [code, setCode] = useState("")
  const { tPlaceholder } = useTranslate()

  const {
    mutate: mutateValidateMfa,
    isLoading: isSubmitting,
    isError,
    reset,
  } = useMutation(postValidateMfa)

  function handleSubmitMfaCode(code: string) {
    void mutateValidateMfa(
      { code },
      {
        onSuccess: (response) => {
          window.location.href = response.redirect_url
        },
      }
    )
  }

  function handleCodeChange(code: string) {
    setCode(code)
    if (isError) {
      reset()
    }
  }

  return (
    <PageLayout
      title={tPlaceholder("Multi-factor authentication")}
      description={tPlaceholder(
        "Enter the code from your authenticator app to complete multi-factor authentication."
      )}
      footer={<Footer />}
      landscapeImageUrl={backdropImage}
      portraitImageUrl={backdropImage}
    >
      <PinInputBox>
        <PinInput
          maxLength={6}
          value={code}
          onChange={handleCodeChange}
          onComplete={handleSubmitMfaCode}
          loading={isSubmitting}
          error={
            isError && !isSubmitting ? tPlaceholder("Invalid code") : undefined
          }
        />
      </PinInputBox>
    </PageLayout>
  )
}

function Footer() {
  const navigate = useNavigate()
  const { tPlaceholder } = useTranslate()

  return (
    <Button
      variant="minimal"
      color="neutral"
      size="small"
      onClick={() => {
        void navigate({ to: "/login" })
      }}
    >
      {tPlaceholder("Return to sign in")}
    </Button>
  )
}

const PinInputBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: ${spacing.XL} 0;
`
